import React from 'react'

const Footer = () => {
  return (
    <div className='absolute-center'>Made with 🔥 by Ashish</div>
  )
}

export default Footer